function dateFromValue(value) {
  if (!value) return null;
  const text = String(value);
  const date = /^\d{4}-\d{2}-\d{2}$/.test(text)
    ? new Date(`${text}T12:00:00`)
    : new Date(text);
  return Number.isNaN(date.getTime()) ? null : date;
}

function localDateKey(value) {
  const date = value instanceof Date ? value : dateFromValue(value);
  if (!date || Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// O álbum precisa de clima somente entre o plantio e a foto mais recente do
// ciclo. Registros de pré-plantio não devem disparar consultas à NASA POWER.
export function calcularPeriodoMeteorologicoFotos(talhao, fotos, referencia = new Date()) {
  const plantio = dateFromValue(talhao?.data_plantio);
  if (!plantio || !Array.isArray(fotos) || fotos.length === 0) return null;

  const colheita = dateFromValue(talhao?.data_colheita);
  const agora = dateFromValue(referencia);
  const limiteFinal = colheita && agora && colheita < agora ? colheita : agora;
  if (!limiteFinal || plantio > limiteFinal) return null;

  const fotosDoCiclo = fotos
    .map(foto => dateFromValue(foto?.data_foto))
    .filter(data => data && data >= plantio && data <= limiteFinal)
    .sort((primeira, segunda) => primeira - segunda);

  if (fotosDoCiclo.length === 0) return null;

  return {
    dataInicio: localDateKey(plantio),
    dataFim: localDateKey(fotosDoCiclo[fotosDoCiclo.length - 1]),
  };
}
